import CloseIcon from "@mui/icons-material/Close";
import {
  Autocomplete,
  Checkbox,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import { useSnackbar } from "notistack";
import { React, useEffect, useState } from "react";
import Files from "react-files";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../AuthContext/AuthContext";
import { api_Routes } from "../../api_Routes";
import { Helper } from "../../tools/Helper";
import SliderSelect from "./SliderSelect";
import { Styles } from "./styles";
const requiredFieldStyle = {
  "& .MuiInputLabel-asterisk": {
    color: "red",
  },
  "& .MuiFormLabel-asterisk": {
    color: "red",
  },
};
const AddPanel = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { auth } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedReadingType, setSelectedReadingType] = useState("api");
  const [IsLoading, setIsLoading] = useState(false);
  const [selectedFont, setSelectedFont] = useState("Mockads");
  const [selectedColor, setSelectedColor] = useState("#EBF2FF");
  const [logoName, setLogoName] = useState("LOREM");
  const [fontSize, setFontSize] = useState(44);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [formData, setFormData] = useState({
    smmpanel_name: "",
    smmpanel_url: "",
    description: "",
    smmpanel_email: "",
    smmpanel_instagram: "",
    smmpanel_skybe: "",
    smmpanel_telegram: "",
    smmpanel_fb: "",
    smmpanel_twitter: "",
    smmpanel_whatsapp: "",
    smmpanel_tel1: "",
    customLogo: "",
    logo: null,
    reading_type: "",
    url_service: "",
    loginpassword: "",
    loginuser: "",
    api_key: "",
    api_url: "",
    country_id: "",
  });
  const [inputValue, setInputValue] = useState("");
  const [paymentMethod, setPaymentMethod] = useState([]);
  const [paymentMethods, setPaymentMethods] = useState([]);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [uploadSliderOption, setUploadSliderOption] = useState("uploadImages");
  // Load countries from localStorage on component mount
  useEffect(() => {
    const loadCountries = () => {
      try {
        const storedCountries = localStorage.getItem("countries");
        if (storedCountries) {
          const parsedCountries = JSON.parse(storedCountries);
          setCountries(parsedCountries);
        }
      } catch (error) {
        console.error("Error loading countries:", error);
      }
    };

    loadCountries();
  }, []);

  // Handle country selection change
  const handleCountryChange = (event, newValue) => {
    setSelectedCountry(newValue);
    setFormData((prev) => ({
      ...prev,
      country_id: newValue?.id || "",
    }));
  };
  const handleAddMethod = () => {
    if (selectedMethod && !paymentMethod.includes(selectedMethod)) {
      setPaymentMethod([...paymentMethod, selectedMethod]);
      setSelectedMethod("");
    }
  };

  const handleDeleteMethod = (index) => {
    setPaymentMethod(paymentMethod.filter((_, i) => i !== index));
  };
  const [uploadOption, setUploadOption] = useState("logo");

  const fonts = ["Mockads", "Escopedia", "Great Vibes"];
  const colors = ["#FFFFFF", "#303030", "#ECA601"];

  const handleUploadOptionChange = (option) => {
    setUploadOption(option);
    if (option === "customLogo") {
      setFormData((prev) => ({ ...prev, customLogo: "" }));
    } else {
      setFormData((prev) => ({ ...prev, logo: null }));
    }
  };

  const handleFileChange = (files) => {
    if (files && files.length > 0) {
      setFormData((prev) => ({ ...prev, logo: files[0] })); // Store the first file
    }
  };

  const handleFontChange = (font) => {
    setSelectedFont(font);
  };

  const handleColorClick = (color) => {
    setSelectedColor(color);
  };

  const handleFontSizeChange = (event, newValue) => {
    setFontSize(newValue);
  };

  const handleChange = (key, value) => {
    setFormData((prev) => ({ ...prev, [key]: value }));
  };
  const handleButtonClick = async () => {
    if (!auth) {
      enqueueSnackbar("please login first ", { variant: "warning" });
      navigate("/login", { state: { from: location } });
    } else {
      await handleSubmit();
    }
  };
  const handleSubmit = async () => {
    const requiredFields = ["smmpanel_name", "smmpanel_url"];

    const updatedFormData = {
      ...formData,
    };

    const missingFields = requiredFields.filter(
      (field) => !updatedFormData[field]
    );

    if (uploadSliderOption === "enterUrls") {
      if (
        !updatedFormData.screenshot_urls ||
        updatedFormData.screenshot_urls.length === 0
      ) {
        updatedFormData.screenshot_urls =
          formData.smmpanel_url?.split(",").map((url) => url.trim()) || [];
      }
    } else if (uploadSliderOption === "uploadImages") {
      if (!updatedFormData.photos || updatedFormData.photos.length === 0) {
        updatedFormData.screenshot_urls =
          formData.smmpanel_url?.split(",").map((url) => url.trim()) || [];
      }
    }
    if (
      !updatedFormData.smmpanel_whatsapp &&
      !updatedFormData.smmpanel_telegram
    ) {
      missingFields.push("Telegram Or Whatsapp");
    }
    if (missingFields.length > 0) {
      enqueueSnackbar(
        `Please fill in all required fields: ${missingFields.join(", ")}`,
        {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
        }
      );
      setIsLoading(false);
      return;
    }

    setIsLoading(true);

    const form_data = new FormData();

    // Append form data based on the active upload option
    if (uploadOption === "logo" && formData.logo) {
      form_data.append("logo", formData.logo);
    } else if (uploadOption === "customLogo") {
      updatedFormData.customLogo = {
        fontSize: `${fontSize}px`,
        color: selectedColor,
        fontFamily: selectedFont,
        logoName: logoName,
      };
      Object.keys(updatedFormData.customLogo).forEach((key) => {
        form_data.append(`customLogo[${key}]`, updatedFormData.customLogo[key]);
      });
    }

    // Append other form data fields
    Object.keys(updatedFormData).forEach((key) => {
      const value = updatedFormData[key];
      if (key !== "logo" && key !== "customLogo") {
        if (key === "screenshot_urls") {
          // Append screenshot_urls as an array if it exists
          if (value.length > 0) {
            value.forEach((url, index) => {
              form_data.append(`screenshot_urls[${index}]`, url);
            });
          } else {
            form_data.append("screenshot_urls", ""); // Append empty string if array is empty
          }
        } else if (key === "photos" && uploadSliderOption === "uploadImages") {
          // Append photos as an array
          if (Array.isArray(value) && value.length > 0) {
            value.forEach((photo, index) => {
              if (photo instanceof File) {
                // New uploaded photo
                form_data.append(`photos[${index}]`, photo);
              } else if (typeof photo === "object" && photo.photo_url) {
                // Existing photo URL
                form_data.append(`photos[${index}]`, photo.photo_url);
              }
            });
          }
        } else if (formData[key] !== "" && formData[key] !== null)
          form_data.append(key, updatedFormData[key]);
      }
    });

    // Append payment methods as an array
    paymentMethod.forEach((method, index) => {
      form_data.append(`paymentMethod[${index}]`, method);
    });

    if (selectedReadingType) {
      form_data.append("reading_type", selectedReadingType);
    }
    const { response, message } = await Helper.Post({
      url: api_Routes.AddPanel.add,
      data: form_data,
      hasToken: true,
    });

    if (response) {
      enqueueSnackbar(message, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      navigate("/");
      setIsLoading(false);
    } else {
      let errorMessage = "";
      if (typeof message === "string") {
        errorMessage = message;
      } else if (typeof message === "object") {
        errorMessage = Object.values(message).flat().join(", ");
      }
      enqueueSnackbar(errorMessage, {
        variant: "error",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
      });
      setIsLoading(false);
    }
  };

  const toggleUploadOption = () => {
    if (uploadOption === "logo") {
      handleUploadOptionChange("customLogo");
    } else {
      handleUploadOptionChange("logo");
    }
  };
  useEffect(() => {
    const getPaymentMethods = async () => {
      const { response, message } = await Helper.Get({
        url: api_Routes.PaymentMethods.get,
        hasToken: true,
      });
      if (response) {
        const methodsArray = response.data.payment_methods.value.split(",");
        setPaymentMethods(methodsArray);
      }
      return response;
    };
    getPaymentMethods();
  }, []);
  return (
    <Styles>
      <Container
        sx={{
          marginBlock: "30px",
          "@media (min-width: 1200px)": {
            maxWidth: "1400px",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            gap: "16px",
          }}
        >
          <Typography
            sx={{
              color: "#474747",
              fontSize: { xs: "20px", sm: "25px", md: "40px" },
              lineHeight: "40px",
              fontWeight: "700",
            }}
          >
            Add Your Own Panel
          </Typography>
          <Typography
            sx={{
              color: "#474747",
              fontSize: "18px",
              lineHeight: "20px",
              fontWeight: "400",
            }}
          >
            add your panel to our database that makes your services reachable
            and your clients increase over time.
          </Typography>
        </Box>
        <Box
          sx={{
            background: "#EBF2FF",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: "50px",
            padding: { xs: "20px", md: "50px" },
            marginTop: "50px",
            borderRadius: "26px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              position: "relative",
            }}
          >
            <Box sx={{ marginBottom: { xs: "20px", md: 0 } }}>
              <Typography
                sx={{
                  color: "#474747",
                  fontWeight: "600",
                  fontSize: "24px",
                  lineHeight: "30px",
                }}
              >
                Main Details
              </Typography>
              <Grid container spacing={1} sx={{ marginTop: "20px" }}>
                <Grid item xs={12} sm={6} md={10}>
                  <TextField
                    label="Panel name"
                    required
                    fullWidth
                    variant="outlined"
                    onChange={(e) => {
                      handleChange("smmpanel_name", e.target.value);
                    }}
                    name="smmpanel_name"
                    size="small" // Makes the TextField smaller
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={10}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Panel Url"
                    required
                    onChange={(e) => {
                      handleChange("smmpanel_url", e.target.value);
                    }}
                    name="smmpanel_url"
                    size="small" // Makes the TextField smaller
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={10}>
                  <FormControl
                    fullWidth
                    sx={{
                      marginTop: "10px",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px",
                      },
                    }}
                  >
                    <InputLabel>Reading Type</InputLabel>
                    <Select
                      value={selectedReadingType}
                      onChange={(e) => setSelectedReadingType(e.target.value)}
                      label="Reading Type"
                      size="small"
                    >
                      <MenuItem value="html">HTML</MenuItem>
                      <MenuItem value="api">API</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {selectedReadingType === "html" && (
                  <>
                    <Grid item xs={12} sm={6} md={10}>
                      <TextField
                        label="URL Service"
                        fullWidth
                        variant="outlined"
                        onChange={(e) =>
                          handleChange("url_service", e.target.value)
                        }
                        size="small"
                        sx={{
                          boxShadow: "-2px 2px 4px #00000040",
                          borderRadius: "10px",
                          backgroundColor: "white",
                          marginTop: "10px",
                          border: "0.5px solid #959595",
                          "& .MuiInputBase-root": {
                            color: "black !important",
                            borderRadius: "10px",
                            padding: "4px 8px", // Reduced padding
                          },
                          "& .MuiOutlinedInput-root": {
                            borderWidth: "1px", // Adjusted border width
                            "&:hover fieldset": {
                              borderColor: "black !important",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black !important",
                            },
                          },
                          "& .MuiInputBase-input": {
                            padding: "8px", // Adjust input padding
                            fontSize: "16px", // Adjust font size if needed
                          },
                        }}
                      />
                    </Grid>
                  </>
                )}

                {selectedReadingType === "api" && (
                  <>
                    <Grid item xs={12} sm={6} md={10}>
                      <TextField
                        label="API Key"
                        required
                        fullWidth
                        variant="outlined"
                        onChange={(e) =>
                          handleChange("smmpanel_api_key", e.target.value)
                        }
                        size="small"
                        sx={{
                          boxShadow: "-2px 2px 4px #00000040",
                          borderRadius: "10px",
                          backgroundColor: "white",
                          marginTop: "10px",
                          border: "0.5px solid #959595",
                          "& .MuiInputBase-root": {
                            color: "black !important",
                            borderRadius: "10px",
                            padding: "4px 8px", // Reduced padding
                          },
                          "& .MuiOutlinedInput-root": {
                            borderWidth: "1px", // Adjusted border width
                            "&:hover fieldset": {
                              borderColor: "black !important",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black !important",
                            },
                          },
                          "& .MuiInputBase-input": {
                            padding: "8px", // Adjust input padding
                            fontSize: "16px", // Adjust font size if needed
                          },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={10}>
                      <TextField
                        label="API URL"
                        required
                        fullWidth
                        variant="outlined"
                        onChange={(e) =>
                          handleChange("smmpanel_api_url", e.target.value)
                        }
                        size="small"
                        sx={{
                          boxShadow: "-2px 2px 4px #00000040",
                          borderRadius: "10px",
                          backgroundColor: "white",
                          marginTop: "10px",
                          border: "0.5px solid #959595",
                          "& .MuiInputBase-root": {
                            color: "black !important",
                            borderRadius: "10px",
                            padding: "4px 8px", // Reduced padding
                          },
                          "& .MuiOutlinedInput-root": {
                            borderWidth: "1px", // Adjusted border width
                            "&:hover fieldset": {
                              borderColor: "black !important",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "black !important",
                            },
                          },
                          "& .MuiInputBase-input": {
                            padding: "8px", // Adjust input padding
                            fontSize: "16px", // Adjust font size if needed
                          },
                        }}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12} sm={12} md={10}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    multiline
                    label="Description"
                    minRows={10} // increases the initial height
                    maxRows={14} // optional, sets a maximum height
                    onChange={(e) => {
                      handleChange("description", e.target.value);
                    }}
                    name="description"
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ width: { md: "100%", lg: "50%" } }}>
              <Typography
                sx={{
                  color: "#474747",
                  fontWeight: "600",
                  fontSize: "24px",
                  lineHeight: "30px",
                }}
              >
                Contacts
              </Typography>
              <Grid container spacing={1} sx={{ marginTop: "28px" }}>
                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    onChange={(e) => {
                      handleChange("smmpanel_email", e.target.value);
                    }}
                    name="smmpanel_email"
                    label="Panel Email"
                    size="small"
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      width: "95%",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="smmpanel_instagram"
                    onChange={(e) => {
                      handleChange("smmpanel_tel1", e.target.value);
                    }}
                    label="Phone number"
                    size="small"
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      width: "95%",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    onChange={(e) => {
                      handleChange("smmpanel_skybe", e.target.value);
                    }}
                    variant="outlined"
                    name="smmpanel_skybe"
                    label="Skype"
                    size="small"
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      width: "95%",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="smmpanel_instagram"
                    onChange={(e) => {
                      handleChange("smmpanel_instagram", e.target.value);
                    }}
                    label="Instagram"
                    size="small"
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      width: "95%",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    onChange={(e) => {
                      handleChange("smmpanel_fb", e.target.value);
                    }}
                    name="smmpanel_fb"
                    label="Facebook"
                    size="small"
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      width: "95%",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="smmpanel_telegram"
                    onChange={(e) => {
                      handleChange("smmpanel_telegram", e.target.value);
                    }}
                    label="Telegram"
                    required
                    size="small"
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      width: "95%",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="smmpanel_whatsapp"
                    onChange={(e) => {
                      handleChange("smmpanel_whatsapp", e.target.value);
                    }}
                    label="Whatsapp"
                    required
                    size="small"
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      width: "95%",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="smmpanel_twitter"
                    onChange={(e) => {
                      handleChange("smmpanel_twitter", e.target.value);
                    }}
                    label="Twitter"
                    size="small"
                    InputLabelProps={{
                      style: {
                        fontSize: "16px",
                        color: "#5F5F5F",
                        lineHeight: "24px",
                        fontWeight: "600",
                      },
                    }}
                    sx={{
                      width: "95%",
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      border: "0.5px solid #959595",
                      "& .MuiInputBase-root": {
                        color: "black !important",
                        borderRadius: "10px",
                        padding: "4px 8px", // Reduced padding
                      },
                      "& .MuiOutlinedInput-root": {
                        borderWidth: "1px", // Adjusted border width
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                      "& .MuiInputBase-input": {
                        padding: "8px", // Adjust input padding
                        fontSize: "16px", // Adjust font size if needed
                      },
                    }}
                  />
                </Grid>
                <Box sx={{ width: "100%", mt: 3 }}>
                  <Typography
                    variant="h6"
                    sx={{
                      mb: 2,
                      color: "#474747",
                      fontWeight: 600,
                      fontSize: "24px",
                    }}
                  >
                    Select Country
                  </Typography>

                  <Autocomplete
                    options={countries}
                    getOptionLabel={(option) => option.label}
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Search country..."
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: "10px",
                            backgroundColor: "white",
                            boxShadow: "-2px 2px 4px #00000040",
                            "& fieldset": {
                              borderColor: "#959595",
                            },
                            "&:hover fieldset": {
                              borderColor: "#303030",
                            },
                            "&.Mui-focused fieldset": {
                              borderColor: "#3F78E0",
                            },
                          },
                        }}
                      />
                    )}
                    sx={{
                      width: "100%",
                      maxWidth: 800,
                      "& .MuiAutocomplete-popupIndicator": {
                        color: "#3F78E0",
                      },
                      "& .MuiAutocomplete-clearIndicator": {
                        color: "#3F78E0",
                      },
                    }}
                    noOptionsText="No countries found"
                  />
                </Box>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  sx={{ position: "relative", marginTop: "20px" }}
                >
                  <Typography
                    sx={{
                      marginBottom: "10px",
                      fontWeight: "600",
                      fontSize: "24px",
                      lineHeight: "30px",
                      color: "#474747",
                    }}
                  >
                    Payment Methods *
                  </Typography>

                  <FormControl
                    fullWidth
                    required
                    size="small"
                    sx={{
                      width: "100%",
                      maxWidth: "400px", // Set maximum width
                      boxShadow: "-2px 2px 4px #00000040",
                      borderRadius: "10px",
                      backgroundColor: "white",
                      marginTop: "10px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "10px",
                        "&:hover fieldset": {
                          borderColor: "black !important",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "black !important",
                        },
                      },
                    }}
                  >
                    <Select
                      multiple
                      value={paymentMethod}
                      onChange={(e) => setPaymentMethod(e.target.value)}
                      displayEmpty
                      inputProps={{
                        "aria-label": "Select payment methods",
                        style: {
                          width: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        },
                      }}
                      sx={{
                        "& .MuiSelect-select": {
                          padding: "8px",
                          fontSize: "16px",
                          whiteSpace: "nowrap", // Prevent wrapping
                          overflow: "hidden",
                          textOverflow: "ellipsis", // Add ellipsis for overflow
                        },
                      }}
                      renderValue={(selected) => {
                        if (selected.length === 0) {
                          return (
                            <Typography style={{ color: "#a0a0a0" }}>
                              Select Payment Methods
                            </Typography>
                          );
                        }
                        // Truncate long lists
                        const displayValues =
                          selected.length > 2
                            ? `${selected.slice(0, 2).join(", ")} +${
                                selected.length - 2
                              } more`
                            : selected.join(", ");

                        return (
                          <Typography noWrap sx={{ maxWidth: "90%" }}>
                            {displayValues}
                          </Typography>
                        );
                      }}
                    >
                      <MenuItem value="" disabled>
                        <Typography>Select Payment Methods</Typography>
                      </MenuItem>
                      {paymentMethods.map((method) => (
                        <MenuItem
                          key={method}
                          value={method}
                          sx={{ whiteSpace: "normal" }}
                        >
                          <Checkbox
                            checked={paymentMethod.indexOf(method) > -1}
                          />
                          {method}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </Box>
          <Box sx={{ width: { xs: "100%", sm: "100%" } }}>
            <Typography
              sx={{
                marginBottom: "10px",
                fontWeight: "600",
                fontSize: "24px",
                lineHeight: "30px",
                color: "#474747",
              }}
            >
              Logo Image *
            </Typography>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                position: "relative",
                justifyContent: "space-between",
                width: "100%",
                gap: { xs: "40px", md: 0 },
              }}
            >
              <Box
                sx={{
                  width: { xs: "100%", md: "45%" },
                  opacity: uploadOption === "customLogo" ? 0.5 : 1,
                  pointerEvents:
                    uploadOption === "customLogo" ? "none" : "auto",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    borderRadius: "10px",
                    alignItems: "center",
                    height: "300px",
                    textAlign: "center",
                    backgroundColor: "#FFFFFF",
                    cursor:
                      uploadOption === "customLogo" ? "not-allowed" : "pointer",
                    position: "relative",
                    border: "#303030 solid 1px",
                    borderRadius: "15px",
                  }}
                >
                  <Files
                    onChange={(fileList) => handleFileChange(fileList)}
                    onError={(error) =>
                      console.error("File upload error:", error)
                    }
                    accepts={["image/*"]}
                    clickable
                    multiple={false}
                    maxFileSize={10485760} // 10MB limit
                    disabled={uploadOption === "customLogo"}
                    style={{
                      opacity: 0,
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      top: 0,
                      left: 0,
                    }}
                  />
                  {formData.logo ? (
                    <Box
                      sx={{
                        position: "relative",
                        width: "80%", // Adjust the size of the image
                        height: "80%",
                        borderRadius: "10px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={URL.createObjectURL(formData.logo)}
                        alt="Uploaded Logo"
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain", // Ensure the image is properly contained
                          borderRadius: "10px",
                        }}
                      />
                      <IconButton
                        onClick={() => {
                          setFormData((prev) => ({ ...prev, logo: null }));
                        }}
                        sx={{
                          position: "absolute",
                          top: "5px",
                          right: "5px",
                          color: "white",
                          backgroundColor: "red",
                          borderRadius: "10px",
                          "&:hover": {
                            backgroundColor: "red",
                          },
                        }}
                      >
                        <CloseIcon />
                      </IconButton>
                    </Box>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Click to upload a logo
                    </Typography>
                  )}
                </Box>
              </Box>
            </Box>
            <SliderSelect
              formData={formData}
              setFormData={setFormData}
              uploadOption={uploadSliderOption}
              setUploadOption={setUploadSliderOption}
            />
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              marginTop: "30px",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{
                textTransform: "none",
                whiteSpace: "nowrap",
                background: "#ECA601",
                padding: "5px 50px",
                borderRadius: "10px",
                // Adding inner shadow using a pseudo-element
                color: "#F1F5FD",
                position: "relative",
                lineHeight: "38px",
                overflow: "hidden",
                fontWeight: "700",
                fontSize: "28px",
                boxShadow: "0px 3px 3px #00000040", // Outer shadow
                "&:before": {
                  content: '""',
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  borderRadius: "0 20px 20px 0",
                  background: "rgba(255, 255, 255, 0.1)", // Color for the inner shadow
                  filter: "blur(4px)",
                  zIndex: 1,
                },
                "&:hover:before": {
                  background: "rgba(255, 255, 255, 0.2)", // Darker on hover for inner shadow
                },
              }}
              onClick={handleButtonClick}
            >
              {IsLoading ? (
                <CircularProgress size={22} sx={{ color: "white" }} />
              ) : (
                "Submit"
              )}
            </Button>
          </Box>
        </Box>
      </Container>
    </Styles>
  );
};

export default AddPanel;
